import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import "./ResumenVuelosDL.css";
import './SharedLoading.css';
import API_BASE_URL from "../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ModalApoyoVuelo from "../components/ModalApoyoVuelo";

const ResumenVuelosPage = () => {
  const token = useSelector((state) => state.auth.token);
  const decoded = token ? jwtDecode(token) : null;

  const [loadingPage, setLoadingPage] = useState(true);
  const [vuelosLlegadas, setVuelosLlegadas] = useState([]);
  const [vuelosSalidas, setVuelosSalidas] = useState([]);
  const [vueloSeleccionado, setVueloSeleccionado] = useState(null);
  // Modal Servicios en sistema (DL)
  const [modalServiciosAbierto, setModalServiciosAbierto] = useState(false);
  const [vueloServiciosSeleccionado, setVueloServiciosSeleccionado] = useState(null);
  const [tipoServiciosSeleccionado, setTipoServiciosSeleccionado] = useState(null); // LLEGADAS | SALIDAS
  const [cantidadServicios, setCantidadServicios] = useState("");
  const [asientosServicios, setAsientosServicios] = useState([]);

  const estacionToken = decoded?.estacion?.trim().toUpperCase();
  const estacionVuelo = (vuelo) =>
    (vuelo?.estacion ?? vuelo?.Estacion ?? vuelo?.station ?? vuelo?.stationCode ?? "")
      .trim()
      .toUpperCase() || null;

  // Modal operadores
  const [modalOperadoresAbierto, setModalOperadoresAbierto] = useState(false);
  const [colaboradores, setColaboradores] = useState([]);
  const [operadoresSeleccionados, setOperadoresSeleccionados] = useState([]);
  const [sillasOperadores, setSillasOperadores] = useState({});
  const [busquedaSiglas, setBusquedaSiglas] = useState("");
  const [registrando, setRegistrando] = useState(false);
  const [apoyoVuelo, setApoyoVuelo] = useState(null); // vuelo para el modal de apoyo



  const llegadaRef = useRef(null);
  const salidaRef = useRef(null);

  // 🔹 Cargar vuelos
  const fetchData = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}api/vuelos/hoyDL`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const vuelos = res.data;

      // Depuración: logs de estaciones y conteos
      const norm = (s) => (s || "").trim().toUpperCase();
      const estacionUsuario = decoded?.estacion ? norm(decoded.estacion) : null;
      const getEstacionVuelo = (v) => norm(v?.estacion ?? v?.Estacion ?? v?.station ?? v?.stationCode);

      console.groupCollapsed("[ResumenVuelosDL] fetchData");
      console.log("Token presente:", Boolean(token));
      console.log("Estación del usuario (token):", estacionUsuario);
      console.log("Total vuelos recibidos:", Array.isArray(vuelos) ? vuelos.length : 0);
      console.log(
        "Ejemplos de campos de estación (primeros 5)",
        (vuelos || []).slice(0, 5).map((v) => ({
          id: v.id,
          estacion: v.estacion,
          Estacion: v.Estacion,
          station: v.station,
          stationCode: v.stationCode,
          norm: getEstacionVuelo(v),
        }))
      );
      const estacionesUnicas = Array.from(new Set((vuelos || []).map((v) => getEstacionVuelo(v)))).sort();
      console.log("Estaciones normalizadas presentes en respuesta:", estacionesUnicas);

      let vuelosFiltrados = vuelos;
      if (estacionUsuario) {
        vuelosFiltrados = (vuelos || []).filter((v) => getEstacionVuelo(v) === estacionUsuario);
        console.log("Coincidencias con estación del usuario:", vuelosFiltrados.length);
        if (vuelosFiltrados.length === 0) {
          console.warn("No hubo coincidencias con estación del usuario. Mostrando todos para depurar.");
          toast.info(
            `No hubo coincidencias para estación ${estacionUsuario}. Mostrando todos para depurar.`,
            { autoClose: 3000 }
          );
        }
      }
      console.groupEnd();

      setVuelosLlegadas(
        vuelosFiltrados
          .filter((v) => v.tipoServicio === "LLEGADAS")
          .sort((a, b) =>
            moment(a.published_arrival_time).diff(moment(b.published_arrival_time))
          )
      );
      setVuelosSalidas(
        vuelosFiltrados
          .filter((v) => v.tipoServicio === "SALIDAS")
          .sort((a, b) =>
            moment(a.published_departure_time).diff(moment(b.published_departure_time))
          )
      );
    } catch (error) {
      console.error("Error al cargar vuelos:", error);
    } finally {
      setLoadingPage(false);
    }
  };

  // 🔹 Abrir modal con operadores
  const abrirModalOperadores = async (vuelo) => {
    try {
      const res = await axios.get(`${API_BASE_URL}api/bitacora/en-turno-detalles`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const disponibles = res.data.filter(
        (c) => c.estacion?.trim().toUpperCase() === decoded?.estacion?.trim().toUpperCase()
      );

      setColaboradores(disponibles);
      setVueloSeleccionado(vuelo);
      setOperadoresSeleccionados([]);
      setModalOperadoresAbierto(true);
    } catch (error) {
      toast.error("Error al obtener operadores");
    }
  };

  // 🔹 Registrar servicios
  const registrarServiciosVuelo = async () => {
    if (registrando) return;
    if (operadoresSeleccionados.length === 0) {
      toast.warning("⚠️ Debes seleccionar al menos un operador");
      return;
    }

    setRegistrando(true);
    try {
      for (const operador of operadoresSeleccionados) {
        const sillaSeleccionada = sillasOperadores[operador.noColaborador] || "WCHR";

        const payload = {
          nombrePax: "",
          aerolinea: "DL",
          noVuelo: vueloSeleccionado.flight_number,
          noAsiento: "S/A",
          origenVuelo: vueloSeleccionado.latest_departure_airport,
          destinoVuelo: vueloSeleccionado.latest_arrival_airport,
          fechaInput: moment().format("YYYY-MM-DD"),
          horaInicio: moment().format("YYYY-MM-DD HH:mm:ss"),
          estacion: decoded?.estacion?.trim().toUpperCase(),
          usuarioInicio: decoded?.id,
          noColaborador: operador.noColaborador,
          statusServicio: "ASIGNADO",
          tipoVuelo: vueloSeleccionado.tipoServicio,
          int_nac: vueloSeleccionado.tipoVuelo,
          pnr: `${vueloSeleccionado.flight_number}-${operador.noColaborador}-${Date.now()}`,
          tipoSilla: sillaSeleccionada,
          conexion: "S/C",
          uh: "UH",
          horaVuelo: moment(
            vueloSeleccionado.tipoServicio === "LLEGADAS"
              ? vueloSeleccionado.published_arrival_time
              : vueloSeleccionado.published_departure_time
          ).format("YYYY-MM-DD HH:mm:ss"),
          sala: vueloSeleccionado.sala || null,
        };

        await axios.post(`${API_BASE_URL}api/servicios/registrar`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      toast.success("✅ Servicios registrados correctamente");
      setModalOperadoresAbierto(false);
    } catch (error) {
      console.error("❌ Error al registrar servicios:", error);
      toast.error("Error al registrar servicios");
    } finally {
      setRegistrando(false);
    }
  };


  // 🔹 Actualizar hora editable
  const actualizarHoraVuelo = async (vuelo, tipo, nuevaHora) => {
    try {
      await axios.put(
        `${API_BASE_URL}api/vuelos/actualizar-hora`,
        { idVuelo: vuelo.id, tipo, nuevaHora },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (tipo === "LLEGADAS") {
        setVuelosLlegadas((prev) =>
          prev.map((v) =>
            v.id === vuelo.id
              ? {
                ...v,
                published_arrival_time: moment(v.published_arrival_time)
                  .set({
                    hour: nuevaHora.split(":")[0],
                    minute: nuevaHora.split(":")[1],
                  })
                  .toISOString(),
              }
              : v
          )
        );
      } else {
        setVuelosSalidas((prev) =>
          prev.map((v) =>
            v.id === vuelo.id
              ? {
                ...v,
                published_departure_time: moment(v.published_departure_time)
                  .set({
                    hour: nuevaHora.split(":")[0],
                    minute: nuevaHora.split(":")[1],
                  })
                  .toISOString(),
              }
              : v
          )
        );
      }

      toast.success("✅ Hora actualizada");
    } catch (err) {
      console.error("❌ Error actualizando hora:", err);
      toast.error("No se pudo actualizar hora");
    }
  };

  // 🔹 Actualizar sala editable
  const actualizarSalaVuelo = async (vuelo, nuevaSala, tipo) => {
    try {
      await axios.put(
        `${API_BASE_URL}api/vuelos/actualizar-sala`,
        { idVuelo: vuelo.id, sala: nuevaSala },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (tipo === "LLEGADAS") {
        setVuelosLlegadas((prev) =>
          prev.map((v) => (v.id === vuelo.id ? { ...v, sala: nuevaSala } : v))
        );
      } else {
        setVuelosSalidas((prev) =>
          prev.map((v) => (v.id === vuelo.id ? { ...v, sala: nuevaSala } : v))
        );
      }

      toast.success("✅ Sala actualizada");
    } catch (err) {
      console.error("❌ Error actualizando sala:", err);
      toast.error("No se pudo actualizar sala");
    }
  };

  // 🔹 Abrir modal Servicios en sistema
  const abrirModalServicios = (vuelo, tipo) => {
    setVueloServiciosSeleccionado(vuelo);
    setTipoServiciosSeleccionado(tipo);
    setCantidadServicios("");
    setAsientosServicios([]);
    setModalServiciosAbierto(true);
  };

  // 🔹 Manejar cambio de cantidad y generar campos de asientos
  const onChangeCantidadServicios = (valor) => {
    const num = String(valor).replace(/[^0-9]/g, "");
    setCantidadServicios(num);
    const n = parseInt(num || "0", 10);
    if (Number.isNaN(n) || n < 0) return;
    setAsientosServicios((prev) => {
      const copia = [...prev];
      if (n > copia.length) {
        return copia.concat(Array(n - copia.length).fill(""));
      } else {
        return copia.slice(0, n);
      }
    });
  };

  // 🔹 Enviar Servicios en sistema a API
  const enviarServiciosSistema = async () => {
    const n = parseInt(cantidadServicios || "0", 10);
    if (!vueloServiciosSeleccionado) return;
    if (!n || n <= 0) {
      toast.warning("Ingresa la cantidad de servicios (número > 0)");
      return;
    }
    if (
      asientosServicios.length !== n ||
      asientosServicios.some((a) => !a || !/^[A-Za-z0-9]+$/.test(String(a)))
    ) {
      toast.warning("Captura todos los asientos (solo letras y números)");
      return;
    }

    try {
      const payload = {
        idVuelo: vueloServiciosSeleccionado.id,
        noVuelo: vueloServiciosSeleccionado.flight_number,
        fechaInput:moment().format("YYYY-MM-DD"),
        cantidadServicios: n,
        asientos: asientosServicios.map((a) => String(a)),
        estacion: estacionToken || estacionVuelo(vueloServiciosSeleccionado),
      };
      await axios.post(
        `${API_BASE_URL}api/vuelos/servicios-vuelo`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("✅ Servicios en sistema actualizados");
      if (tipoServiciosSeleccionado === "LLEGADAS") {
        setVuelosLlegadas((prev) =>
          prev.map((v) =>
            v.id === vueloServiciosSeleccionado.id ? { ...v, cantidadServicios: n } : v
          )
        );
      } else if (tipoServiciosSeleccionado === "SALIDAS") {
        setVuelosSalidas((prev) =>
          prev.map((v) =>
            v.id === vueloServiciosSeleccionado.id ? { ...v, cantidadServicios: n } : v
          )
        );
      }

      toast.success("✅ Servicios en sistema actualizados");
      setModalServiciosAbierto(false);
    } catch (error) {
      console.error("❌ Error actualizando servicios en sistema:", error);
      toast.error("No se pudo actualizar servicios en sistema");
    }
  };

  // 🔹 Render tabla
  const handleClickServicios = (vuelo, tipo) => {
    const existe =
      vuelo && vuelo.cantidadServicios !== undefined && vuelo.cantidadServicios !== null && String(vuelo.cantidadServicios) !== "";
    if (existe) {
      const confirmar = window.confirm(
        "Ya existe un registro de sillas para este vuelo. ¿Deseas sobreescribir el registro actual?"
      );
      if (!confirmar) {
        setModalServiciosAbierto(false);
        return;
      }
    }
    abrirModalServicios(vuelo, tipo);
  };

  // 🔹 Render tabla
  const renderTabla = (vuelos, tipo, ref) => (
    <div className="tabla-resumen">
      <h2>{tipo}</h2>
      <div className="scroll-wrapper" ref={ref}>
        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Vuelo</th>
              <th>Origen</th>
              <th>Destino</th>
              <th>Hora</th>
              <th>Vue. en sistema</th>
              <th>Tipo</th>
              <th>Sala</th>
              <th>Apoyo</th>
            </tr>
          </thead>
          <tbody>
            {vuelos.map((vuelo, idx) => {
              const horaVuelo =
                tipo === "LLEGADAS"
                  ? moment(vuelo.published_arrival_time)
                  : moment(vuelo.published_departure_time);

              return (
                <tr
                  key={vuelo.id}
                  onClick={() => abrirModalOperadores(vuelo)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{idx + 1}</td>
                  <td>{vuelo.flight_number}</td>
                  <td>{vuelo.latest_departure_airport}</td>
                  <td>{vuelo.latest_arrival_airport}</td>
                  <td onClick={(e) => e.stopPropagation()}>
                    <input
                      type="time"
                      defaultValue={horaVuelo.format("HH:mm")}
                      onBlur={(e) =>
                        actualizarHoraVuelo(vuelo, tipo, e.target.value)
                      }
                    />
                  </td>
                  <td onClick={(e) => e.stopPropagation()}>
                    <input
                      type="text"
                      readOnly
                      value={
                        vuelo.cantidadServicios !== undefined && vuelo.cantidadServicios !== null
                          ? String(vuelo.cantidadServicios)
                          : ""
                      }
                      onClick={() => handleClickServicios(vuelo, tipo)}
                      className="input-vuelo-sistema"
                      style={{ width: "80px", backgroundColor: "#f0f0f0" }}
                    />
                  </td>
                  <td>{vuelo.tipoVuelo}</td>
                  <td onClick={(e) => e.stopPropagation()}>
                    <input
                      type="text"
                      defaultValue={vuelo.sala || ""}
                      onBlur={(e) =>
                        actualizarSalaVuelo(vuelo, e.target.value.trim(), tipo)
                      }
                      className="input-sala editable"
                      style={{ width: "80px" }}
                    />
                  </td>
                  <td onClick={(e) => e.stopPropagation()}>
                    <button
                      className="btn-apoyo-vuelo"
                      onClick={() => setApoyoVuelo(vuelo)}
                      title="Asignar operador de apoyo (no genera noshow)"
                    >
                      + Apoyo
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );

  useEffect(() => {
    if (token) fetchData();
  }, [token]);

  if (loadingPage) {
    return (
      <div className="resumen-vuelos-container">
        <div className="page-loading-overlay">
          <div className="page-loading-spinner" />
          <p className="page-loading-text">Cargando resumen de vuelos...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="resumen-vuelos-container">
      {renderTabla(vuelosLlegadas, "LLEGADAS", llegadaRef)}
      {renderTabla(vuelosSalidas, "SALIDAS", salidaRef)}

      {/* 🔹 Modal de operadores con scroll */}
      {modalOperadoresAbierto && (
        <div className="modal-overlay-pasajeros">
          <div className="modal-pasajeros">
            <h3>
              Asignar operadores al vuelo {vueloSeleccionado?.flight_number}
            </h3>
            <input
              type="text"
              placeholder="Buscar por siglas..."
              value={busquedaSiglas}
              onChange={(e) => setBusquedaSiglas(e.target.value.toUpperCase())}
              className="input-busqueda"
              style={{ marginBottom: "10px", width: "100%", padding: "6px" }}
            />

            <div className="tabla-scroll" style={{ maxHeight: "400px", overflowY: "auto" }}>
              <table className="tabla-pasajeros">
                <thead>
                  <tr>
                    <th></th>
                    <th>#</th>
                    <th>Nombre</th>
                    <th>Siglas</th>
                    <th>Tipo de Silla</th>
                  </tr>
                </thead>
                <tbody>
                  {colaboradores
                    .filter((c) => c.siglas.toUpperCase().includes(busquedaSiglas))
                    .map((c, idx) => (
                      <tr key={c.noColaborador}>
                        <td>
                          <input
                            type="checkbox"
                            checked={operadoresSeleccionados.some(
                              (op) => op.noColaborador === c.noColaborador
                            )}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setOperadoresSeleccionados((prev) => [...prev, c]);
                              } else {
                                setOperadoresSeleccionados((prev) =>
                                  prev.filter((op) => op.noColaborador !== c.noColaborador)
                                );
                              }
                            }}
                          />
                        </td>
                        <td>{idx + 1}</td>
                        <td>{c.nombreCompleto}</td>
                        <td>{c.siglas}</td>
                        <td>
                          <select
                            value={sillasOperadores[c.noColaborador] || "WCHR"}
                            onChange={(e) =>
                              setSillasOperadores((prev) => ({
                                ...prev,
                                [c.noColaborador]: e.target.value,
                              }))
                            }
                          >
                            <option value="WCHR">WCHR</option>
                            <option value="WCHS">WCHS</option>
                          </select>
                        </td>
                      </tr>
                    ))}
                </tbody>


              </table>
            </div>
            <div className="text-end">
              <button
                className="btn-registrar"
                onClick={registrarServiciosVuelo}
                disabled={registrando}
              >
                {registrando ? "Registrando..." : "Registrar servicios"}
              </button>
              <button
                className="btn-cerrar"
                onClick={() => setModalOperadoresAbierto(false)}
              >
                ✖ Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 🔹 Modal Servicios en sistema (DL) */}
      {modalServiciosAbierto && (
        <div className="modal-overlay-pasajeros">
          <div className="modal-pasajeros">
            <h3>Servicios en sistema</h3>
            <div style={{ marginBottom: "10px" }}>
              <label style={{ display: "block", marginBottom: 4 }}>Cantidad de servicios</label>
              <input
                type="number"
                min={1}
                inputMode="numeric"
                value={cantidadServicios}
                onChange={(e) => onChangeCantidadServicios(e.target.value)}
                placeholder="Ej. 1, 2, 3..."
                style={{ width: "100%", padding: 6 }}
              />
            </div>

            {asientosServicios.length > 0 && (
              <div className="tabla-scroll" style={{ maxHeight: 300, overflowY: "auto", marginBottom: 10 }}>
                <table className="tabla-pasajeros">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Número de asiento</th>
                    </tr>
                  </thead>
                  <tbody>
                    {asientosServicios.map((val, idx) => (
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td>
                          <input
                            type="text"
                            inputMode="text"
                            value={val}
                            onChange={(e) => {
                              const alnum = e.target.value.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
                              setAsientosServicios((prev) => {
                                const copia = [...prev];
                                copia[idx] = alnum;
                                return copia;
                              });
                            }}
                            placeholder="Ej. 10D"
                            style={{ width: "100%", padding: 6 }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            <div className="text-end">
              <button className="btn-registrar" onClick={enviarServiciosSistema}>
                Guardar
              </button>
              <button className="btn-cerrar" onClick={() => setModalServiciosAbierto(false)}>
                ✖ Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      <ModalApoyoVuelo
        vuelo={apoyoVuelo}
        aerolineaFallback="DL"
        onClose={() => setApoyoVuelo(null)}
      />

      <ToastContainer />
    </div>
  );
};

export default ResumenVuelosPage;
